import React from "react";
import {  Col, Pagination, PaginationItem, PaginationLink, Row, Table } from "reactstrap";

const TablaPaginada = ({ cabecera  , datos, currentPage, totalPage, setCurrentPage}) => {
  return (
    <>
     
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            {cabecera}
          </thead>
          <tbody>
            {datos}
          </tbody>
        </Table>

        {setCurrentPage ?
       
        <nav aria-label="...">
         

                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    
                    <PaginationItem className={`${currentPage === 0 ? "disabled" : ""}`}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage - 1)} 
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    
             
                    <PaginationItem className={`${currentPage === totalPage - 1 ? "disabled" : ""}`}>
                      <PaginationLink
                       onClick={() => setCurrentPage(currentPage + 1)} 
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
          <Row>
            <Col className="text-right">

              <span>Página {currentPage + 1} de {totalPage} </span>
            </Col>
          </Row>
                </nav>
                
       
      :""}
    </>
  );
};

export default TablaPaginada;
